import { Link } from "react-router-dom";
import HeroCarousel from "@/pages/home/components/HeroCarousel";
import CategoryQuickLinks from "@/pages/home/components/CategoryQuickLinks";
import FeaturedColumns from "@/pages/home/components/FeaturedColumns";
import TagCloud from "@/pages/home/components/TagCloud";
import { getTodayHeadlines, allNews } from "@/utils/news";

export default function Home() {
  const headlines = getTodayHeadlines(5);
  const total = allNews.length;

  return (
    <div className="w-full px-4 md:px-6 py-6">
      <div className="max-w-[1280px] mx-auto flex flex-col gap-10">
        {/* 焦点轮播 */}
        <HeroCarousel items={headlines} />

        {/* 分类快捷入口 */}
        <CategoryQuickLinks />

        {/* 今日热榜速览 */}
        <section className="w-full bg-background-50 border border-background-200 rounded-lg p-5">
          <div className="flex items-center gap-2 mb-3">
            <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-50 text-primary-600">
              <i className="ri-flashlight-line text-lg"></i>
            </span>
            <h2 className="font-heading font-bold text-lg text-foreground-950">今日热榜速览</h2>
          </div>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {headlines.map((item, i) => (
              <Link
                key={item.id}
                to={`/detail/${item.id}`}
                className="flex items-center gap-2 text-sm text-foreground-700 hover:text-primary-600 transition-colors cursor-pointer max-w-full"
              >
                <span
                  className={`w-5 h-5 shrink-0 flex items-center justify-center rounded text-xs font-bold ${
                    i < 3
                      ? "bg-primary-500 text-background-50"
                      : "bg-background-200 text-foreground-600"
                  }`}
                >
                  {i + 1}
                </span>
                <span className="line-clamp-1">{item.title}</span>
              </Link>
            ))}
          </div>
        </section>

        {/* 精选栏目 */}
        <FeaturedColumns />

        {/* 热门标签云 */}
        <TagCloud />

        {/* 站点简介 */}
        <section className="w-full bg-background-100 border border-background-200 rounded-lg p-6 md:p-8">
          <div className="flex flex-col md:flex-row md:items-center gap-6">
            <div className="flex-1">
              <h2 className="font-heading font-black text-xl md:text-2xl text-foreground-950 mb-3">
                关于 51吃瓜官网
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-3xl">
                51吃瓜官网致力于为关注娱乐圈动态、社会热门事件和网络热点的广大网民，提供实时、权威且生动的资讯内容。我们持续追踪最新娱乐新闻、社会热点与网络趣闻，让你在碎片化时间里也能快速掌握全面、多元化的热点资讯。
              </p>
              <Link
                to="/about"
                className="inline-flex items-center gap-1 mt-4 text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer"
              >
                了解更多
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-3 gap-4 md:gap-6 md:border-l md:border-background-300 md:pl-8">
              <div>
                <div className="font-heading font-black text-2xl text-primary-600">{total}+</div>
                <div className="text-xs text-foreground-500 mt-1">精品内容</div>
              </div>
              <div>
                <div className="font-heading font-black text-2xl text-primary-600">3</div>
                <div className="text-xs text-foreground-500 mt-1">内容频道</div>
              </div>
              <div>
                <div className="font-heading font-black text-2xl text-primary-600">7×24</div>
                <div className="text-xs text-foreground-500 mt-1">持续更新</div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}